"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var React = _interopRequireWildcard(require("react"));

var _prefix = require("./prefix");

var _default = function _default(props) {
  var classPrefix = props.classPrefix,
      rest = (0, _objectWithoutPropertiesLoose2.default)(props, ["classPrefix"]);
  return function (WrappedComponent) {
    var DefaultPropsComponent =
    /*#__PURE__*/
    function (_WrappedComponent) {
      (0, _inheritsLoose2.default)(DefaultPropsComponent, _WrappedComponent);

      function DefaultPropsComponent() {
        return _WrappedComponent.apply(this, arguments) || this;
      }

      var _proto = DefaultPropsComponent.prototype; // for IE9 & IE10 support

      _proto.render = function render() {
        return _WrappedComponent.prototype.render.call(this);
      };

      return DefaultPropsComponent;
    }(WrappedComponent);

    (0, _defineProperty2.default)(DefaultPropsComponent, "contextTypes", WrappedComponent.contextTypes);
    (0, _defineProperty2.default)(DefaultPropsComponent, "childContextTypes", WrappedComponent.childContextTypes);
    (0, _defineProperty2.default)(DefaultPropsComponent, "getDerivedStateFromProps", WrappedComponent.getDerivedStateFromProps);
    (0, _defineProperty2.default)(DefaultPropsComponent, "defaultProps", (0, _extends2.default)({}, WrappedComponent.defaultProps, {
      classPrefix: classPrefix ? "" + (0, _prefix.getClassNamePrefix)() + classPrefix : undefined
    }, rest));
    (0, _defineProperty2.default)(DefaultPropsComponent, "handledProps", ["classPrefix"]);
    return DefaultPropsComponent;
  };
};

exports.default = _default;